import { render, staticRenderFns } from "./MonthlyObjective.vue?vue&type=template&id=8551aa72&scoped=true"
import script from "./MonthlyObjective.vue?vue&type=script&lang=js"
export * from "./MonthlyObjective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8551aa72",
  null
  
)

export default component.exports